
import { Component, Vue } from "vue-property-decorator";
import config from "./config";
import { LogHelper } from "@/common/LogHelper";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import { WeighbridgeBll } from "@/common/glboalconstant";
import {
  uploadWeight,
  checkCodesAndType,
  getCqNoByCpNo,
  getCQInfoByCode,
  weight,
} from "@/api/service";
import {
  ApiQueryType,
  SendDataType,
  ReceiveDataType,
} from "@/common/glboalconstant";
import { ScanforWeighBridgeModule } from "@/store/modules/store_scanforweighbridge";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form3",
  components: {
    YtoTable,
    Scan,
  },
  computed: {
    activePageNow() {
      return ScanforWeighBridgeModule.activePage;
    },
  },
  watch: {
    activePageNow: function(now) {
      if (now == "item") {
        if (typeof obj_DWS_Core !== "undefined") {
          obj_DWS_Core.registerJavaScriptCallback(
            "DWSReceiveDataSetPackageData",
            (value) => {
              LogHelper.Console("DWS传输过来的参数1");
              LogHelper.Console(value);
              this.ReceiveDataEvent(JSON.parse(value));
            }
          );
        }
      }
    },
  },
})
export default class extends Vue {
  public globalConfig: any = {};
  public loginData: any = {};
  private serialNumber = "";

  mounted() {
    try {
      if (typeof obj_DWS_Core !== "undefined") {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            LogHelper.Console("DWS传输过来的参数1");
            LogHelper.Console(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
      this.InitIOStatus();
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
    } catch (error) {
      console.log("地磅称重1Vue出现异常:" + error);
    }
  }
  private ReceiveDataEvent(receiveDataEventArgs) {
    switch (receiveDataEventArgs.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        break;
      case ReceiveDataType.PackageData:
        this.SetPackageData(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );

        break;
      case ReceiveDataType.CodeCheck:
        break;
      case ReceiveDataType.ErrorState:
        break;
      case ReceiveDataType.ErrorInfo:
        this.SetErrorInfo(JSON.parse(receiveDataEventArgs.JsonData.toString()));

        break;
    }
  }
  /// <summary>
  /// 获得错误信息
  /// </summary>
  /// <param name="errorInfo"></param>
  public SetErrorInfo(errorInfo) {
    if (errorInfo.ErrorString.indexOf("重量") != -1) {
      this.CleanWeightInput();
    }
    this.errormessage = errorInfo.ErrorString;
  }
  /// <summary>
  /// 清空重量
  /// </summary>
  private CleanWeightInput() {
    this.formmodel1.input_RoughWeight = "";
    this.formmodel1.input_SuttleWeight = "";
    this.formmodel1.input_LoadingWeight = "";
    this.formmodel1.input_UnloadingWeight = "";
    this.formmodel1.input_WeightDate = "";
    this.serialNumber = "";
  }
  /// <summary>
  /// 获得底层数据
  /// </summary>
  /// <param name="data"></param>
  public SetPackageData(data) {
    this.WeighResponse(parseFloat(data.weight.toString()));
  }
  /// <summary>
  /// 称重-Response
  /// </summary>
  private WeighResponse(weight) {
    debugger;
    this.formmodel1.input_RoughWeight = weight.toString();

    var response = this.Weight(
      this.formmodel1.input_CQ,
      this.formmodel1.input_IoStatus,
      this.formmodel1.input_RoughWeight,
      this.formmodel1.input_TareWeight
    );
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "计算重量失败, 错误信息:" +
        response?.respMessage +
        "，错误代码：" +
        response?.respcode;
      return;
    }
    this.formmodel1.input_NetWeight = response.data.latestOrgSuttleWeight;
    this.formmodel1.input_UnloadingWeight = response.data.unloadingWeight;
    this.formmodel1.input_LoadingWeight = response.data.loadingWeight;
    this.formmodel1.input_SuttleWeight = response.data.suttleWeight;
    this.formmodel1.input_WeightDate = response.data.weighingTimeStr;

    this.serialNumber = response.data.serialNumber;
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  public datahistorycallback(datahistory) {
    this.showPrintedList = datahistory;
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public InitIOStatus() {
    let statusListObj = WeighbridgeBll.IoStatusList;
    this.options = statusListObj.map((item) => {
      return { label: `${item.key}`, value: `${item.value}` };
    });
    if (this.options.length > 0) {
      this.formmodel1.input_IoStatus = this.options[0].value;
      console.log(
        "this.formmodel1.input_IoStatus:" +
          this.formmodel1.input_IoStatus.toString()
      );
    }
  }
  private errormessage = "";
  private deviceItems: deviceItem[] = [];
  public ytoCode = "";
  //扫描区扫码
  private ytocodeget() {
    debugger;
    this.formmodel1.input_ScanCode = this.ytoCode.toUpperCase();
    this.CQQueryFacade();
  }
  public CQQueryFacade() {
    this.errormessage = "";

    let cqNo: any = this.formmodel1.input_ScanCode;
    // #region 1.1、校验车签规则

    if (this.IsNullorEmptyorUndefined(cqNo)) {
      this.errormessage = "车签号不能为空";
      return;
    }

    var rg = JSON.parse(checkCodesAndType(cqNo.split()));
    if (rg.ResultCode == "200") {
      if (rg.Type == ApiQueryType.strCarCode) {
        if (
          cqNo.toString().indexOf("CQ") != -1 &&
          cqNo.toString().length == 20
        ) {
          this.errormessage = "系统生成的车签，不允许人工录入";
          return;
        }
      } else if (rg.Type == ApiQueryType.strCarInfoCode) {
        if (this.formmodel1.input_IoStatus == "2") {
          cqNo = this.DoWithCarInfoCode(cqNo, "1");
        } else {
          cqNo = this.DoWithCarInfoCode(cqNo, "2");
        }
        if (this.IsNullorEmptyorUndefined(cqNo)) {
          this.errormessage = "未查询到车签号，请重扫或直接扫描车签号条码！";
          return;
        }
      } else {
        this.errormessage = "条码错误";
        return;
      }
    } else {
      this.errormessage = "条码错误";
      return;
    }

    // #endregion

    // #region 1.2、查询车签接口，并带出车签信息

    var response = this.GetCQInfoByCode(cqNo);
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "车签查询失败, 错误信息:" +
        response?.respMessage +
        "，错误代码：" +
        response?.respcode;
      return;
    }

    this.formmodel1.input_CarNumber =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.carNumber)
        ? ""
        : response.data.carNumber;
    this.formmodel1.input_CarNumberExtend =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.carNumberExtend)
        ? ""
        : response.data.carNumberExtend;
    this.formmodel1.input_LineCode =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.lineCode)
        ? ""
        : response.data.lineCode;
    this.formmodel1.input_LineName =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.lineName)
        ? ""
        : response.data.lineName;
    this.formmodel1.input_SourceOrgCode =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.sourceOrgCode)
        ? ""
        : response.data.sourceOrgCode;
    this.formmodel1.input_SourceOrgCodeName =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.sourceOrgCodeName)
        ? ""
        : response.data.sourceOrgCodeName;
    this.formmodel1.input_TareWeight =
      response.data == null ||
      this.IsNullorEmptyorUndefined(response.data.tareWeight.toString())
        ? ""
        : response.data.tareWeight.toString();

    this.formmodel1.input_CQ = cqNo;

    // #endregion

    // #region 1.3、触发称重事件

    this.WeighRequest(cqNo);
    //tbx_scanArea.Text = "";
    this.formmodel1.input_ScanCode = "";
    // #endregion
  }
  private WeighRequest(key) {
    debugger;
    if (this.IsNullorEmptyorUndefined(this.formmodel1.input_CQ)) {
      this.errormessage = "车签号不能为空";
      return;
    }

    if (this.globalConfig.WeighConfig.On) {
      var weight = 0.0;
      try {
        weight = this.GetWeight(key);
      } catch (ex) {
        this.errormessage = "取重错误:" + ex;
        return;
        //throw;
      }

      if (weight < 0) {
        this.errormessage = "取重错误";
        return;
      }

      this.formmodel1.input_RoughWeight = weight.toFixed(2);

      let strTareWeight = this.IsNullorEmptyorUndefined(
        this.formmodel1.input_TareWeight
      )
        ? "0"
        : this.formmodel1.input_TareWeight;
      var response = this.Weight(
        this.formmodel1.input_CQ,
        this.formmodel1.input_IoStatus,
        this.formmodel1.input_RoughWeight,
        strTareWeight
      );
      if (response == null || response.respcode != "000") {
        this.errormessage =
          "计算重量失败, 错误信息:" +
          response?.respMessage +
          "，错误代码：" +
          response?.respcode;
        return;
      }
      this.formmodel1.input_NetWeight = response.data.latestOrgSuttleWeight;
      this.formmodel1.input_UnloadingWeight = response.data.unloadingWeight;
      this.formmodel1.input_LoadingWeight = response.data.loadingWeight;
      this.formmodel1.input_SuttleWeight = response.data.suttleWeight;
      this.formmodel1.input_WeightDate = response.data.weighingTimeStr;
      // // callbackdic["updateformdatacallback"]?.ExecuteAsync(this.formmodel1);
      this.serialNumber = response.data.serialNumber;
    } else {
      obj_DWS_Core.hKSocketSynSendDataCallBack(
        SendDataType.SuppleCode,
        WeighbridgeBll.DefaultWaybillNo
      );
    }
  }
  /// <summary>
  /// 根据毛重、皮重、车签号、进出状态 ，计算装车重量、卸车重量、流水号和称重时间。
  /// </summary>
  /// <param name="cqNo"></param>
  /// <param name="ioStatus"></param>
  /// <param name="roughWeight"></param>
  /// <param name="tareWeight"></param>
  /// <returns></returns>
  public Weight(cqNo, ioStatus, roughWeight, tareWeight) {
    let request = {
      devType: "0",
      devMac: this.globalConfig.LocalMac,
      body: {
        containerNo: cqNo,
        ioStatus: ioStatus,
        roughWeight: roughWeight,
        tareWeight: tareWeight,
      },
    };
    return JSON.parse(weight(JSON.stringify(request)));
  }
  //取重方法
  private GetWeight(scanContent) {
    try {
      let weight = obj_Weight_Core.weighbridgeGetWeight(scanContent);
      weight = Math.floor(weight * 100) / 100;
      return weight;
    } catch (error) {
      return 0;
    }
  }
  private GetCQInfoByCode(cqNo) {
    let request = {
      devType: "0",
      devMac: this.globalConfig.LocalMac,
      body: {
        viewType: "1",
        queryValue: cqNo,
        queryType: "17",
      },
    };
    return JSON.parse(getCQInfoByCode(JSON.stringify(request)));
  }
  /// <summary>
  /// 根据CP码查询车签
  /// </summary>
  /// <param name="carCodeInfo"></param>
  /// <returns></returns>
  private DoWithCarInfoCode(carCodeInfo, inOut = "1") {
    let carCode = "";
    try {
      let jbody = {
        queryValue: carCodeInfo,
        queryType: "30",
        viewType: "",
        extend1: inOut, //1表示上车/封车/发车/出场、2表示下车/到车/解车/进场/串行回磅
        extend2: "",
        extend3: "",
      };

      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: this.globalConfig.CurrentDeviceType.toString(),
        body: jbody,
      };
      var response = JSON.parse(getCqNoByCpNo(JSON.stringify(request)));

      let jresponse = response.data;
      if (jresponse.extend1 != null) {
        carCode = jresponse.extend1;
      }
    } catch (ex) {
      LogHelper.WriteLog("地磅称重 DoWithCarInfoCode" + ex);
    }
    return carCode;
  }
  public carlabel = "";
  private config = config;

  private formmodel1: inputDataModel_WeighbridgeItem = {
    input_ScanCode: "",
    input_IoStatus: "",
    input_LineCode: "",
    input_LineName: "",
    input_CQ: "",
    input_SourceOrgCode: "",
    input_SourceOrgCodeName: "",
    input_CarNumber: "",
    input_CarNumberExtend: "",
    input_RoughWeight: "",
    input_TareWeight: "",
    input_SuttleWeight: "",
    input_LoadingWeight: "",
    input_UnloadingWeight: "",
    input_WeightDate: "",
    input_NetWeight: "",
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: "",
    },
  ];
  public PrintAndUploadFunc() {
    debugger;
    //进场时对比净重
    if (this.formmodel1.input_IoStatus == "1") {
      let suttleWeight = this.IsNullorEmptyorUndefined(
        this.formmodel1.input_SuttleWeight
      )
        ? "0"
        : this.formmodel1.input_SuttleWeight;
      let netWeight = this.IsNullorEmptyorUndefined(
        this.formmodel1.input_NetWeight
      )
        ? "0"
        : this.formmodel1.input_NetWeight;
      if (
        Math.abs(
          parseFloat(suttleWeight.toString()) - parseFloat(netWeight.toString())
        ) >= 500
      ) {
        this.$confirm(
          "本次称重（净重）与上一中心（净重）差\r\n异过大，是否继续上传！",
          "提示",
          {
            confirmButtonText: "继续上传",
            cancelButtonText: "否",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "继续上传",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消上传",
            });
            return;
          });

      }
    }
    try {
      let response = this.UPLOAD();
      if (response == null || response.data == null) {
        return;
      }

      var printData = response.data;
      printData.ioStatusText = WeighbridgeBll.IoStatusList.filter(
        (item) => item.value == printData.ioStatus
      )[0].key;
      printData.statusText = printData.status == "1" ? "已上传" : "未上传";
      obj_ScanForWeighbridge.printTicket("item", JSON.stringify(printData));

    } catch (ex) {
      LogHelper.WriteLog("打印失败:" + ex.toString());
      this.errormessage = "打印失败, 错误信息:" + ex.Message;
    }
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  public UploadFunc() {
    debugger;
    try {
      //进场时对比净重
      if (this.formmodel1.input_IoStatus == "1") {
        let suttleWeight = this.IsNullorEmptyorUndefined(
          this.formmodel1.input_SuttleWeight
        )
          ? "0"
          : this.formmodel1.input_SuttleWeight;
        let netWeight = this.IsNullorEmptyorUndefined(
          this.formmodel1.input_NetWeight
        )
          ? "0"
          : this.formmodel1.input_NetWeight;
        if (
          Math.abs(
            parseFloat(suttleWeight.toString()) -
              parseFloat(netWeight.toString())
          ) > 500
        ) {
          this.$confirm(
            "本次称重（净重）与上一中心（净重）差\r\n异过大，是否继续上传！",
            "提示",
            {
              confirmButtonText: "继续上传",
              cancelButtonText: "否",
              type: "warning",
            }
          )
            .then(() => {
              this.$message({
                type: "success",
                message: "继续上传",
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消上传",
              });
              return;
            });
        }
      }
      this.UPLOAD();
    } catch (error) {
      console.log(error);
    }
  }
  /// <summary>
  /// 上传
  /// </summary>
  private UPLOAD() {
    debugger;
    if (this.IsNullorEmptyorUndefined(this.formmodel1.input_CQ)) {
      this.errormessage = "车签号不能为空";
      return null;
    }

    if (
      this.IsNullorEmptyorUndefined(this.formmodel1.input_RoughWeight) ||
      parseFloat(this.formmodel1.input_RoughWeight.toString()) <= 0
    ) {
      this.errormessage = "请称重";
      return null;
    }

    let listWeightWarning = "";
    if (parseFloat(this.formmodel1.input_SuttleWeight.toString()) < 0) {
      listWeightWarning += "[净重]";
    }

    if (parseFloat(this.formmodel1.input_LoadingWeight.toString()) < 0) {
      listWeightWarning += "[装车重量]";
    }

    if (parseFloat(this.formmodel1.input_UnloadingWeight.toString()) < 0) {
      listWeightWarning += "[卸车重量]";
    }

    if (listWeightWarning.length > 0) {
      let msg = listWeightWarning + " 小于0\r\n是否继续上传";
      this.$confirm(msg, "提示", {
        confirmButtonText: "继续上传",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "继续上传",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消上传",
          });
          return;
        });
    }

    var request = this.GetCurrentUploadWeightRequest();
    var response = JSON.parse(uploadWeight(JSON.stringify(request)));
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "上传失败, 错误信息:" +
        response?.respMessage +
        "，错误代码：" +
        response?.respcode;
      return null;
    }

    if (response.data == null) {
      this.errormessage = "上传成功，数据返回失败。";
      return null;
    }

    this.InsertMyDataView(response.data);
    this.CleanInput();

    return response;
  }
  /// <summary>
  /// 新增列表
  /// </summary>
  /// <param name="data"></param>
  /// <returns></returns>
  private InsertMyDataView(data) {

    this.showPrintedList.push({
      containerNo: data.containerNo,
      // ioStatus : WeighbridgeBLL.GetIoStatusText(data.ioStatus),
      ioStatus: WeighbridgeBll.IoStatusList.filter(
        (item) => item.value == data.ioStatus
      )[0].key,
      roughWeight: data.roughWeight,
      tareWeight: data.tareWeight,
      suttleWeight: data.suttleWeight,
      loadingWeight: data.loadingWeight,
      unloadingWeight: data.unloadingWeight,
      weighingTimeStr: data.weighingTimeStr,
      lineName: data.lineName,
      sourceOrgCodeName: data.sourceOrgCodeName,
      carNumber: data.carNumber,
      carNumberExtend: data.carNumberExtend,
      serialNumber: data.serialNumber,
      opOrgName: data.opOrgName,
      opUserName: data.opUserName,
      status: data.status == "1" ? "已上传" : "未上传",
      memo: data.memo,
    });

    return true;
  }
  /// <summary>
  /// 上传成功，清空文本框
  /// </summary>
  private CleanInput() {
    this.formmodel1.input_CQ = "";
    this.formmodel1.input_CarNumber = "";
    this.formmodel1.input_CarNumberExtend = "";
    this.formmodel1.input_LineCode = "";
    this.formmodel1.input_LineName = "";
    this.formmodel1.input_SourceOrgCode = "";
    this.formmodel1.input_SourceOrgCodeName = "";

    this.formmodel1.input_RoughWeight = "";
    this.formmodel1.input_TareWeight = "";
    this.formmodel1.input_SuttleWeight = "";
    this.formmodel1.input_LoadingWeight = "";
    this.formmodel1.input_UnloadingWeight = "";
    this.formmodel1.input_WeightDate = "";
    this.formmodel1.input_NetWeight = "";
    this.formmodel1.input_ScanCode = "";
    this.serialNumber = "";
  }
  /// <summary>
  /// 获得当前上传重量请求信息
  /// </summary>
  /// <returns></returns>
  private GetCurrentUploadWeightRequest() {
    return {
      devMac: this.globalConfig.LocalMac,
      devType: this.globalConfig.CurrentDeviceType.toString(),
      body: {
        aviType: 0,
        isFirstTransfer: 1,
        mac: this.globalConfig.LocalMacIPv4,
        mty: "0140",
        trace: 0,
        opRecord: {
          carNumber: this.formmodel1.input_CarNumber,
          carNumberExtend: this.formmodel1.input_CarNumberExtend,
          containerNo: this.formmodel1.input_CQ,
          ioStatus: this.formmodel1.input_IoStatus,
          lineCode: this.formmodel1.input_LineCode,
          lineName: this.formmodel1.input_LineName,
          loadingWeight: this.formmodel1.input_LoadingWeight,
          opUserCode: this.loginData.userCode,
          opUserName: this.loginData.employeeName,
          roughWeight: this.formmodel1.input_RoughWeight,
          serialNumber: this.serialNumber,
          sourceOrgCode: this.formmodel1.input_SourceOrgCode,
          sourceOrgCodeName: this.formmodel1.input_SourceOrgCodeName,
          suttleWeight: this.formmodel1.input_SuttleWeight,
          tareWeight: this.formmodel1.input_TareWeight,
          unloadingWeight: this.formmodel1.input_UnloadingWeight,
          weighingTimeStr: this.formmodel1.input_WeightDate,
        },
      },
    };
  }
  public ReweighFunc() {
    debugger;
    this.formmodel1.input_ScanCode = this.ytoCode.toUpperCase();
    this.WeighRequest(this.formmodel1.input_ScanCode);
  }
}
